import React, { FC } from 'react';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import { Accordion } from 'react-bootstrap';
import TrainingHistoryForm from '../forms/training-history-form';
import { useDispatch, useSelector } from 'react-redux';
import { EducationHistoryModel, TrainingHistoryModel } from '../../../../shared/models/employee.model';
import { handleEmployeeSectionAddNewData } from '../../../../shared/utils/function-state';
import SectionAddRow from '../section-add-row';
import {
    getCurrentEmployee,
    getCurrentEmployeeEditProfile,
    getEmployeeAction
} from '../../../../shared/services/employee-service';

interface EmployeeTrainingHistoryProps {
    defaultKey?: AccordionEventKey;
}

const EmployeeTrainingHistory: FC<EmployeeTrainingHistoryProps> = ({defaultKey = '0'}) => {
    const dispatch = useDispatch();
    const employee = useSelector(getCurrentEmployee);
    const employeeAction = useSelector(getEmployeeAction);

    const employeeEditProfile = useSelector(getCurrentEmployeeEditProfile);
    const haveSomeEditField = () => {
        if (employeeAction.type === 'view-edit-request') {
            const lengthNotSame = employee.training_histories.length !== employeeEditProfile.training_histories.length;

            if (lengthNotSame)
                return true;

            return employee.training_histories.some((data, index) => {
                return Object.keys(data).some(key => {
                    const kk = key as keyof TrainingHistoryModel;
                    if (key === 'id' || key === 'employee_id' || key === 'created_at'  || key === 'updated_at' || key === 'from_id')
                        return false;
                    return employeeEditProfile.training_histories[index][kk] !== data[kk];
                });
            });
        }
        return false;
    };

    const onAddNewData = () => {
        const initData: TrainingHistoryModel = {
            id: null,
            employee_id: null,
            course: null,
            course_type: null,
            location: null,
            year: null,
            file: null,
            new_file: true,
            file_name: '',
            from_id: null,
        };
        handleEmployeeSectionAddNewData('training_histories', initData, dispatch);
    };


    return (
        <Accordion defaultActiveKey={defaultKey} className="mt-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className={`text-mof-primary ${haveSomeEditField() ? 'accordion-warning' : ''}`}>
                    <h5 className="text-mof-primary m-0">ประวัติการฝึกอบรม</h5>
                </Accordion.Header>
                <Accordion.Body>
                    <TrainingHistoryForm/>
                    <SectionAddRow onAddNewData={onAddNewData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default EmployeeTrainingHistory;